module.exports = __webpack_public_path__ + "static/emorial_bg-41455577cae221225c177741dbb984e5.jpg";